<template>
    <div class="timeline scroll">
        <div class="row wrapper">
            <div id="drawing"></div>
            <div class="col-6 col-no-padding theoric-patrol" :class="{show:showTheoricPatrol}">
                <h2>Théorique</h2>
                <div class="first-delay" :style="getHeightFirstDelay"></div>
                <div v-for="(checkpoint,key) in theoric" class="checkpoint timeline-checkpoint"
                     :class="[getStateClass(checkpoint),{'with-times':manageTime}]" :style="getStyle(checkpoint,key)">
                    <div class="col-flex col-number">
                        <div class="number" :data-number="key + 1">{{ key + 1 }}</div>
                        <div class="travel-time" v-show="manageTime">{{ getTravelTime(checkpoint, key) }}</div>
                    </div>
                    <div class="col-flex col-hours">
                        <span class="time-with-delta start" v-show="manageTime">
                            {{ getMinTimeFromDelta(checkpoint) }}
                        </span>
                        <span class="time" v-show="manageTime">
                            {{ getTimeWithoutDelta(checkpoint) }}
                        </span>
                        <span class="time-with-delta end" v-show="manageTime">
                            {{ getMaxTimeFromDelta(checkpoint) }}
                        </span>
                    </div>
                    <div class="col-flex col-icon">
                        <i class="icon fa-fw" :class="iconAP(checkpoint.type)"></i>
                    </div>
                    <div class="col-flex col-description">
                        <div class="description">
                            <span class="name">{{ checkpoint.name }}</span><span class="path"
                                                                                 v-html="constructPath(checkpoint.plans)"></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6 col-no-padding real-patrol" :class="{show:showRealPatrol}">
                <h2>Réel</h2>
                <div class="first-delay" :style="getHeightRealFirstDelay"></div>
                <div v-for="(checkpoint,key) in real" v-show="checkpoint.id != null"
                     class="checkpoint timeline-checkpoint"
                     :class="[getStateClass(checkpoint),{'with-times':manageTime}]" :style="getStyle(checkpoint,key)">
                    <div class="col-flex col-number">
                        <div class="number" :data-number="getRealNumber(checkpoint.id,key)">
                            {{ getRealNumber(checkpoint.id, key) }}
                        </div>
                        <div class="travel-time" v-show="manageTime">{{ getRealTravelTime(checkpoint, key) }}</div>
                    </div>
                    <div class="col-flex col-hours">
                        <span class="time" v-show="manageTime">
                            {{ getRealTime(checkpoint) }}
                        </span>
                    </div>
                    <div class="col-flex col-icon">
                        <i class="icon fa-fw" :class="realIconAP(checkpoint)"></i>
                    </div>
                    <div class="col-flex col-description">
                        <div class="description">
                            <span class="name">{{ getRealName(checkpoint) }}</span><span class="path"
                                                                                         v-html="constructRealPath(checkpoint)"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    const timeScale = 12;
    const numberSize = 36;
    const numberOffset = numberSize / 2;

    import moment from 'moment';
    import SVG from 'svg.js';
    import zepto from 'webpack-zepto';

    import Icons from '@/services/iconMapping.js';

    import _findIndex from 'lodash/findIndex';
    import _findLastIndex from 'lodash/findLastIndex';
    import _filter from 'lodash/filter';


    export default {
        beforeDestroy() {
            window.removeEventListener('resize', this.getWindowWidth);
            window.removeEventListener('resize', this.getWindowHeight);
        },
        computed: {
            timeScale: function () {
                return this.zoom;
            },
            getHeightFirstDelay: function () {
                if (this.theoricStart != null && this.realStart != null && this.manageTime) {
                    var theoric = moment(this.theoricStart, 'HH:mm');
                    var real = moment(this.realStart, 'HH:mm');
                    if (theoric.isBefore(real)) {
                        return 'height: 0px;';
                    }
                    else {
                        var diff = theoric.diff(real, 'minutes');
                        if (diff > 100) {
                            diff /= 3;
                        }
                        return 'height:' + ((diff) * this.timeScale) + 'px';

                    }
                }
                return '';
            },
            getHeightRealFirstDelay: function () {
                if (this.theoricStart != null && this.realStart != null && this.manageTime) {
                    var theoric = moment(this.theoricStart, 'HH:mm');
                    var real = moment(this.realStart, 'HH:mm');
                    if (theoric.isBefore(real)) {
                        var diff = real.diff(theoric, 'minutes');
                        if (diff > 100) {
                            diff /= 3;
                        }
                        return 'height:' + ((diff) * this.timeScale) + 'px';
                    }
                    else {
                        return 'height: 0px;';
                    }
                }
                return '';
            },
        },
        data() {
            return {
                draw: null,
                showTheoricPatrol: false,
                showRealPatrol: false,
                windowWidth: 0,
                windowHeight: 0,
                lines: [],
                timers: [],
                timeout: null,
            }
        },
        methods: {
            iconAP: function (type) {
                return Icons.actionpoints[type]
            },
            realIconAP: function (checkpoint) {
                if (checkpoint.id) {
                    return Icons.actionpoints[this.apDefs[checkpoint.id].type];
                }
                return '';
            },
            constructPath: function (plans) {
                if (plans != null) {
                    var output = '';
                    for (var i = 0; i < plans.length; i++) {
                        var plan = plans[i];

                        output += '<span><i class="icon-plan ' + Icons.plans[plan.type] + '"></i>' + plan.name + '</span>';

                        if (i < plans.length - 1) {
                            output += '<i class="fa fa-chevron-right"></i>';
                        }
                    }

                    return output;
                }
                return '';

            },
            constructRealPath: function (checkpoint) {
                var plans = null;
                if (this.apDefs[checkpoint.id]) {
                    plans = this.apDefs[checkpoint.id].plans;
                }
                if (plans != null) {
                    var output = '';
                    for (var i = 0; i < plans.length; i++) {
                        var plan = plans[i];

                        output += '<span><i class="icon-plan ' + Icons.plans[plan.type] + '"></i>' + plan.name + '</span>';

                        if (i < plans.length - 1) {
                            output += '<i class="fa fa-chevron-right"></i>';
                        }
                    }

                    return output;
                }
                return '';

            },
            getRealNumber: function (id, index) {


                if (id != null) {
                    var all = _filter(this.theoric, {id: id, present: 1});

                    if(all.length > 1){
                        return _findIndex(this.theoric, {id: id, present: 1},index) + 1;
                    }
                    else{
                        return _findIndex(this.theoric, {id: id, present: 1}) + 1;
                    }
                }
                return ''
            },
            getRealName: function (checkpoint) {
                if (this.apDefs[checkpoint.id]) {
                    return this.apDefs[checkpoint.id].name;
                }
                return '';
            },
            getStateClass(checkpoint) {
                if (this.real != null && this.real.length > 0) {
                    if (checkpoint.present != null) {
                        if (checkpoint.present == 1) {
                            if(this.manageTime){
                                if (checkpoint.inTime == 1) {
                                    return 'state-right';
                                }
                                else {
                                    return 'state-not-in-time';
                                }
                            }
                            else{
                                return 'state-right';
                            }

                        }
                        else {
                            return 'state-wrong';
                        }
                    }
                }

            },
            getTravelTime(checkpoint, index) {
                if (checkpoint.travelTimeSinceStart != null && this.theoric[index + 1]) {
                    const travelTime = ((this.theoric[index + 1].travelTimeSinceStart - checkpoint.travelTimeSinceStart) / 60);
                    return travelTime ? travelTime + ' min' : '';
                }
                return '';
            },
            getRealTravelTime(checkpoint, index) {
                if (this.real[index + 1]) {
                    var duration = this.searchNextDuration(index + 1);
                    if(duration != ''){
                        return duration + ' min';
                    }
                    else{
                        return '';
                    }

                }
                return '';
            },
            searchNextDuration(index){
                if(index < this.real.length){
                    if(this.real[index].id != null){
                        return Math.round(this.real[index].duration / 60);
                    }
                    else{
                        return this.searchNextDuration(index + 1);
                    }
                }
                else{
                    return '';
                }
            },
            getMinTimeFromDelta(checkpoint) {
                if (checkpoint.travelTimeSinceStart != null && checkpoint.delta != 0 && this.theoricStart) {
                    return moment(this.theoricStart, 'HH:mm').add(checkpoint.travelTimeSinceStart, 'seconds').subtract(checkpoint.delta, 'seconds').format('HH:mm');
                }
                return '';
            },
            getMaxTimeFromDelta(checkpoint) {
                if (checkpoint.travelTimeSinceStart != null && checkpoint.delta != 0 && this.theoricStart) {
                    return moment(this.theoricStart, 'HH:mm').add(checkpoint.travelTimeSinceStart, 'seconds').add(checkpoint.delta, 'seconds').format('HH:mm');
                }
                return '';
            },
            getTimeWithoutDelta(checkpoint){
                if (checkpoint.travelTimeSinceStart != null && checkpoint.delta === 0 && this.theoricStart) {
                    return moment(this.theoricStart, 'HH:mm').add(checkpoint.travelTimeSinceStart, 'seconds').format('HH:mm');
                }
                return '';
            },
            getRealTime(checkpoint) {
                if (checkpoint.id) {
                    return moment(checkpoint.seenAt).format('HH:mm');
                }
                return '';

            },
            getStyle: function (checkpoint, index) {
                var style = '';
                style += ' ' + this.getHeight(checkpoint, index);
                return style;
            },
            getHeight: function (checkpoint, index) {
                if(this.manageTime) {
                    if (checkpoint.duration != null) {

                        //Math.round(this.real[index].duration / 60)

                        if (this.real[index + 1]) {
                            var duration = this.searchNextDuration(index + 1);
                            if (duration != '') {
                                return 'height:' + (duration * this.timeScale) + 'px';
                            }
                        }

                    }
                    else {
                        if (this.theoric[index + 1]) {
                            if (this.theoric[index + 1].id != null) {
                                const calcHeight = (Math.round((this.theoric[index + 1].travelTimeSinceStart - checkpoint.travelTimeSinceStart) / 60) * this.timeScale);
                                return calcHeight ? 'height:' + calcHeight + 'px' : 'height: 90px';
                            }
                            else {
                                if (this.theoric[index + 2]) {
                                    const calcHeight = (Math.round((this.theoric[index + 2].travelTimeSinceStart - checkpoint.travelTimeSinceStart) / 60) * this.timeScale);
                                    return calcHeight ? 'height:' + calcHeight + 'px' : 'height: 90px';
                                }
                            }
                        }
                    }
                }

                return '';
            },
            drawLines: function (animation, move) {

                if (animation == null) {
                    animation = true;
                }

                if (move == null) {
                    move = false;
                }


                if (move !== true) {
                    this.draw.clear();
                    this.lines = [];
                    this.clearTimers();
                }

                //if (this.manageTime) {


                    var container = zepto('.timeline .wrapper')[0];
                    var parentPos = zepto(container).offset();

                    var numbers = zepto('.theoric-patrol .checkpoint .number');
                    var numbers2 = zepto('.real-patrol .checkpoint .number');

                    var checkpoints1 = zepto('.theoric-patrol .checkpoint');
                    var checkpoints2 = zepto('.real-patrol .checkpoint');

                    var diff1 = 0;
                    var diff2 = 0;

                    for (var i = 0; i < numbers.length; i++) {
                        if (this.theoric[i].present === 1) {
                            var child = zepto(numbers[i]);
                            var childNumber = child.data('number');
                            var child2 = zepto('.real-patrol .checkpoint .number[data-number="' + childNumber + '"]');
                            if (child2.length > 0) {
                                child2 = zepto(child2[0]);


                                var childPos = child.offset();
                                var childPos2 = child2.offset();

                                if (childPos2.top != 0) {

                                    var childOffset = {
                                        top: childPos.top - parentPos.top,
                                        left: childPos.left - parentPos.left
                                    }

                                    var childOffset2 = {
                                        top: childPos2.top - parentPos.top,
                                        left: childPos2.left - parentPos.left
                                    }

                                    if (move === false) {
                                        if (animation === true) {
                                            this.timers[i] = setTimeout(this.drawLine.bind(this, childOffset, childOffset2, child, animation, i), (1000 + (i * 200)));
                                        }
                                        else {
                                            this.drawLine(childOffset, childOffset2, child, animation, i);

                                        }
                                    }
                                    else {
                                        if (this.real[i] != null) {
                                            var oldHeight1 = zepto(checkpoints1[i]).height();
                                            var newHeight1 = parseInt(this.getHeight(this.theoric[i], i).replace('px', '').replace('height:', ''));
                                            diff1 = diff1 + (newHeight1 - oldHeight1);

                                            var checkpoint2 = child2.parent();
                                            var oldHeight2 = zepto(checkpoint2).height();
                                            var newHeight2 = parseInt(this.getHeight(this.real[i], i).replace('px', '').replace('height:', ''));
                                            diff2 = diff2 + (newHeight2 - oldHeight2);


                                            var line = this.lines[i + 1];
                                            if (line != null) {
                                                line.animate(200, '>').plot(line.attr('x1'), line.attr('y1') + diff1, line.attr('x2'), line.attr('y2') + diff2);
                                            }
                                        }


                                    }


                                }
                                else {
                                    this.lines[i] = null;
                                }
                            }
                            else {
                                this.lines[i] = null;
                            }
                        }
                        else{
                            this.lines[i] = null;
                        }

                    }
                //}


            },
            drawLine: function (point1, point2, child, animation, index) {
                if (animation == null) {
                    animation = true;
                }
                var line = this.draw.line(point1.left + numberOffset, point1.top + numberOffset, point2.left + numberOffset, point2.top + numberOffset).attr('class', 'line');
                this.lines[index] = line;
                if (animation === true) {
                    line.attr('class', 'line animated');
                }
                line.stroke({
                    color: child.css('background-color'),
                    width: 5,
                    linecap: 'butt',
                    linejoin: 'miter'
                });
            },
            getWindowSize(event) {
                this.draw.clear();
                this.clearTimers();
                this.drawLines(false);
            },
            clearTimers(){
                for(var tKey in this.timers){
                    clearTimeout(this.timers[tKey]);
                }
                this.timers = [];
            }

        },
        mounted: function () {
            this.draw = SVG('drawing');
            this.$nextTick(function () {
                window.addEventListener('resize', this.getWindowSize);

                //Init
                this.getWindowSize()
            })
        },
        name: '',
        props: {
            theoric: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            real: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            links: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            manageTime: {
                type: Boolean,
                default: false
            },
            theoricStart: {
                type: String,
                default: null
            },
            realStart: {
                type: String,
                default: null
            },
            apDefs: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            zoom: {
                type: Number,
                default: 10
            }
        },
        updated: function () {

        },
        watch: {
            theoric: {
                handler: function (newValue, oldValue) {
                    if(newValue && newValue.length > 0) {
                        this.showTheoricPatrol = true;
                    }
                    else{
                        this.showTheoricPatrol = false;
                    }
                },
                deep: true
            },
            real: {
                handler: function (newValue, oldValue) {
                    this.draw.clear();
                    this.clearTimers();
                    if (newValue != null && newValue.length > 0) {
                        this.showRealPatrol = true;
                        setTimeout(() => {
                            this.drawLines();
                        }, 300);
                    }
                    else {
                        this.showRealPatrol = false;
                    }


                },
                deep: true
            },
            theoricStart: function () {
                this.draw.clear();
                this.clearTimers();
            },
            zoom: function (newValue, oldValue) {
                this.draw.clear();
                this.clearTimers();
                if (this.timeout != null) {
                    clearTimeout(this.timeout);
                }
                this.timeout = setTimeout(() => {
                    this.drawLines(false);
                }, 300);
            }

        }
    }
</script>

<style lang="scss" scoped>

</style>
